/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { LayerPickerIconProps } from '../iconUtilities';

export const TemperatureIcon = memo(({ 
    backgroundFillColor = '#82BC00',
    symbolFillColor = '#FFFFFF',
    width = 43,
    height = 43
}: LayerPickerIconProps) =>
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='12' cy='12' r='12' fill={backgroundFillColor} />
        <path fillRule='evenodd' clipRule='evenodd' d='M10.1302 5.6334C10.1302 4.60397 10.9647 3.76923 11.9944 3.76923C13.0238 3.76923 13.8585 4.60395 13.8585 5.6334V13.7481C14.9524 14.3889 15.688 15.5767 15.688 16.9371C15.688 18.977 14.0342 20.6308 11.9944 20.6308C9.95425 20.6308 8.30069 18.977 8.30069 16.9371C8.30069 15.5767 9.03631 14.3889 10.1302 13.7481V5.6334ZM11.9944 5.43077C11.8824 5.43077 11.7917 5.52148 11.7917 5.6334V6.8H12.197V5.6334C12.197 5.52159 12.1062 5.43077 11.9944 5.43077ZM12.197 8H11.7917V9H12.197V8ZM11.7917 11.6V10.2H12.197V11.6H11.7917ZM11.7917 12.8V14.7397L11.0369 15.1443C10.3796 15.4966 9.96223 16.1795 9.96223 16.9371C9.96223 18.0594 10.872 18.9692 11.9944 18.9692C13.1166 18.9692 14.0265 18.0593 14.0265 16.9371C14.0265 16.1795 13.6091 15.4966 12.9519 15.1443L12.197 14.7397V12.8H11.7917Z' fill={symbolFillColor}/>
    </svg>
);